module.exports = __webpack_public_path__ + "images/templates/navigation/member-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/templates/navigation/member-icon.png
// module id = 109
// module chunks = 0